import React from 'react';

import ConsumerConfirm from '../consumer-confirm/ConsumerConfirm';

function PageWthConfirmation({ isConfirmed, onConfirm, children }) {
  if (!isConfirmed) {
    return <ConsumerConfirm onConfirm={onConfirm} />;
  }

  return children;
}

export default PageWthConfirmation;
